export const VIEW_STATUS_ACTION_ID = 'VIEW_STATUS';
export const ADD_ACTION_ID = 'ADD';

export const ACTION_IDS = {
	VIEW_STATUS: VIEW_STATUS_ACTION_ID,
	ADD: ADD_ACTION_ID
} as const;
